(function () {
  'use strict';

  // Custom parts finder — talks to Flipside API directly (the backend WMPF
  // uses). Replaces WMPF's dropdown UI with our own progressive picker:
  // Make → Model → Year. WMPF's script is still loaded on the page so we
  // can extract the JWT from its inline <script> tag.

  var FLIPSIDE_BASE = 'https://flipside-api.whitesplatform.com/v1';
  var STORAGE_KEY = 'gcdbp:selectedBike';
  // WMPF reads its bike selection from this exact localStorage key. Writing
  // to it in WMPF's expected shape lets WMPF's results page skip the
  // (currently failing) URL-param → ID resolution step.
  var WMPF_STORAGE_KEY = 'seeker-dropdown-parts-finder-2025-state';

  var root = document.querySelector('[data-cpf-root]');
  if (!root) return;

  // Note: the "saved bike" chip lives OUTSIDE the accordion, so it stays
  // visible even when the picker panel is collapsed. We query it from
  // document, not from `root` (which is the picker form scope).
  var el = {
    saved: document.querySelector('[data-cpf-saved]'),
    savedBike: document.querySelector('[data-cpf-saved-bike]'),
    change: document.querySelector('[data-cpf-change]'),
    form: root.querySelector('[data-cpf-form]'),
    make: root.querySelector('[data-cpf-make]'),
    model: root.querySelector('[data-cpf-model]'),
    year: root.querySelector('[data-cpf-year]'),
    submit: root.querySelector('[data-cpf-submit]'),
    error: root.querySelector('[data-cpf-error]'),
    accordion: root.closest('.seeker-accordion')
  };

  function extractToken() {
    var scripts = document.querySelectorAll('script');
    for (var i = 0; i < scripts.length; i++) {
      var text = scripts[i].textContent || '';
      var m = text.match(/dist\.dropdown\.js\?data-token=([^&"'\\]+)/);
      if (m) return m[1];
    }
    return null;
  }

  function api(token, path) {
    return fetch(FLIPSIDE_BASE + path, {
      headers: { 'Authorization': 'Bearer ' + token }
    }).then(function (r) {
      if (!r.ok) throw new Error('API ' + r.status + ' on ' + path);
      return r.json();
    });
  }

  function readStored() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) {
      return null;
    }
  }

  function writeStored(bike) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(bike)); } catch (e) {}
    // Mirror to WMPF's storage so its results page renders without a
    // separate name→ID resolution round trip.
    try {
      localStorage.setItem(WMPF_STORAGE_KEY, JSON.stringify({
        year: bike.year,
        make_id: bike.makeId,
        model_id: bike.modelId,
        heading: bike.makeName + ' ' + bike.modelName + ' ' + bike.year
      }));
    } catch (e) {}
  }

  function clearStored() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (e) {}
    try { localStorage.removeItem(WMPF_STORAGE_KEY); } catch (e) {}
  }

  function setError(msg) {
    if (!el.error) return;
    el.error.textContent = msg || '';
    el.error.hidden = !msg;
  }

  function setOption(select, value, text, data) {
    var opt = document.createElement('option');
    opt.value = value;
    opt.textContent = text;
    if (data) {
      Object.keys(data).forEach(function (k) { opt.dataset[k] = data[k]; });
    }
    select.appendChild(opt);
  }

  function resetSelect(select, placeholder) {
    select.innerHTML = '';
    setOption(select, '', placeholder);
    select.disabled = true;
  }

  var token = extractToken();
  if (!token) {
    setError('Parts finder failed to initialise. Please refresh.');
    return;
  }

  var cache = { makes: null, modelsByMake: {} };
  var selection = { makeId: null, makeName: null, modelName: null, year: null, modelId: null };

  function showSavedChip(bike) {
    if (!el.saved || !el.savedBike) return;
    el.savedBike.textContent = bike.makeName + ' ' + bike.modelName + ' ' + bike.year;
    el.saved.hidden = false;
    // Hide the accordion entirely while a bike is set. The chip becomes
    // the only visible parts-finder UI; Change opens the accordion again.
    if (el.accordion) el.accordion.hidden = true;
  }

  function hideSavedChip() {
    if (el.saved) el.saved.hidden = true;
    if (el.accordion) el.accordion.hidden = false;
  }

  function closeAccordion() {
    if (!el.accordion) return;
    el.accordion.setAttribute('data-open', 'false');
    var trigger = el.accordion.querySelector('.seeker-accordion__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'false');
  }

  function openAccordion() {
    if (!el.accordion) return;
    el.accordion.setAttribute('data-open', 'true');
    var trigger = el.accordion.querySelector('.seeker-accordion__trigger');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
  }

  function populateMakes(makes) {
    el.make.innerHTML = '';
    setOption(el.make, '', 'Select Make');
    makes.forEach(function (m) {
      setOption(el.make, m.id, m.name, { name: m.name });
    });
    el.make.disabled = false;
  }

  el.make.addEventListener('change', function () {
    var makeId = this.value;
    resetSelect(el.model, 'Select Model');
    resetSelect(el.year, 'Select Year');
    el.submit.disabled = true;
    if (!makeId) return;

    selection.makeId = makeId;
    selection.makeName = this.options[this.selectedIndex].dataset.name;
    setError('');

    var serveModels = function (models) {
      cache.modelsByMake[makeId] = models;
      var names = Array.from(new Set(models.map(function (m) { return m.name; }))).sort();
      el.model.innerHTML = '';
      setOption(el.model, '', 'Select Model');
      names.forEach(function (n) { setOption(el.model, n, n); });
      el.model.disabled = false;
    };

    if (cache.modelsByMake[makeId]) {
      serveModels(cache.modelsByMake[makeId]);
    } else {
      api(token, '/models/make/' + encodeURIComponent(makeId))
        .then(serveModels)
        .catch(function () { setError('Could not load models. Try again.'); });
    }
  });

  el.model.addEventListener('change', function () {
    var modelName = this.value;
    resetSelect(el.year, 'Select Year');
    el.submit.disabled = true;
    if (!modelName) return;

    selection.modelName = modelName;
    var models = cache.modelsByMake[selection.makeId] || [];
    var years = Array.from(new Set(
      models.filter(function (m) { return m.name === modelName; })
            .map(function (m) { return m.year; })
    )).sort(function (a, b) { return b - a; });

    el.year.innerHTML = '';
    setOption(el.year, '', 'Select Year');
    years.forEach(function (y) { setOption(el.year, y, y); });
    el.year.disabled = false;
  });

  el.year.addEventListener('change', function () {
    var year = parseInt(this.value, 10);
    el.submit.disabled = true;
    if (!year) return;

    selection.year = year;
    var models = cache.modelsByMake[selection.makeId] || [];
    var match = models.find(function (m) {
      return m.name === selection.modelName && m.year === year;
    });
    selection.modelId = match ? match.id : null;
    if (selection.modelId) el.submit.disabled = false;
  });

  el.submit.addEventListener('click', function () {
    if (!selection.modelId) return;
    writeStored(selection);
    showSavedChip(selection);
    closeAccordion();
    // If user is already on a collection page, reload so the in-collection
    // filter applies the new bike. Otherwise jump straight to the filtered
    // /collections/all view so the user doesn't have to click "Browse
    // parts that fit" as a second action.
    if (/\/collections\//.test(window.location.pathname)) {
      window.location.reload();
    } else {
      window.location.href = '/collections/all';
    }
  });

  if (el.change) {
    el.change.addEventListener('click', function () {
      clearStored();
      selection = { makeId: null, makeName: null, modelName: null, year: null, modelId: null };
      hideSavedChip();
      if (el.make.options.length) el.make.value = '';
      resetSelect(el.model, 'Select make first');
      resetSelect(el.year, 'Select model first');
      el.submit.disabled = true;
      openAccordion();
      // No navigation — Change is "swap bike", not "exit". The submit
      // handler will reload the page when the user picks a new bike.
    });
  }

  // Restore from storage if there's an existing selection — show the chip
  // straight away so the user knows their bike is set.
  var stored = readStored();
  if (stored && stored.makeName && stored.modelName && stored.year && stored.modelId) {
    selection = stored;
    showSavedChip(stored);
  }

  // Always load makes (so the picker is ready when user wants to change)
  api(token, '/makes')
    .then(function (makes) {
      cache.makes = makes.sort(function (a, b) { return a.name.localeCompare(b.name); });
      populateMakes(cache.makes);
    })
    .catch(function () { setError('Could not load makes. Refresh to retry.'); });
})();
